module.exports = __webpack_public_path__ + "static/media/detail-empretec-rural-mobile.5e0d0f53.png";